import { SceneGraphNode } from "../../internal";
/**
 * Creates a point geometry
 *
 * @class GeometryNode
 * @extends {SceneGraphNode}
 * @constructor
 */
export class GeometryNode extends SceneGraphNode {
    styletextureloaded(texture) {
        if (texture.needsUpdate) {
            this.currentTraversalState.scene.render();
        }
    }
}
//# sourceMappingURL=geometrynode.js.map